import { MentionInputBox } from "../../ui/MentionInputBox";

const CommentForm = ({ value = "", onChange, onSubmit, onBack }) => {
    console.log(value);
  return (
    <div
      className="comment-form"
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        border: '0px solid #ccc',
        borderRadius: '8px',
        padding: '16px',
        backgroundColor: '#fff',
        boxSizing: 'border-box',
        position: 'relative',
      }}
    >
      <MentionInputBox
        label="Comment"
        name="comment"
        placeholder="Write a comment... (Mention MLNO/COnD with prefix @)"
        value={value}
        onChange={onChange}
        style={{
          width: '95%',
          height: '80px',
          marginBottom: '16px',
          borderRadius: '4px',
          padding: '10px',
          border: '1px solid #ccc',
          resize: 'none',
        }}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <button
          onClick={onSubmit}
          style={{
            padding: '10px 16px',
            backgroundColor: '#059a99',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Add Comment
        </button>
        <button
          onClick={onBack}
          style={{
            padding: '10px 16px',
            backgroundColor: '#ccc',
            color: '#000',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Return
        </button>
      </div>
    </div>
  );
};

export default CommentForm;